import { useEffect, useRef, useState } from "react";

import { useAuth, useDebounce, useMerchantApiQuery } from "../hooks";
import { IOnboardingStatus } from "../interfaces-and-types";

export const useShowOnboardingRequired = (delayMs = 2500) => {
  const isDebounceElapsed = useDebounce(delayMs);

  const { active_tenant_id } = useAuth();

  useEffect(() => {
    // hide if tenant switched
    setShowOnboardingRequired(false);
  }, [active_tenant_id]);

  // console.log(
  //   "isDebounceElapsed useShowOnboardingRequired: ",
  //   isDebounceElapsed
  // );

  const { isSuccess, data: onboardingStatus } =
    useMerchantApiQuery<IOnboardingStatus>("getOnboardingStatus", {
      enabled: isDebounceElapsed,
    });

  const [showOnboardingRequired, setShowOnboardingRequired] = useState(false);
  const closeOnboardingRequired = () => setShowOnboardingRequired(false);

  // console.log(
  //   "showOnboardingRequired useShowOnboardingRequired: ",
  //   showOnboardingRequired
  // );

  let timeoutId = useRef<NodeJS.Timeout>();

  useEffect(() => {
    console.log("Running effect for useShowOnboardingRequired...");

    if (
      isDebounceElapsed &&
      isSuccess &&
      !onboardingStatus?.is_account_verification_successful
    ) {
      timeoutId.current = setTimeout(
        () => setShowOnboardingRequired(true),
        delayMs
      );
    }

    return () => timeoutId && clearTimeout(timeoutId.current);
  }, [isSuccess, isDebounceElapsed]);

  return {
    showOnboardingRequired,
    onboardingStatus,
    closeOnboardingRequired,
  };
};
